// Scoped styles for the contact form, injected inside the shadow root.
// `:host { all: initial }` resets inherited host-page styles for isolation.
// Colours are driven by CSS custom properties so the form can switch between a
// light and dark palette via a `data-theme` attribute on the form element. The
// brand accent (--ax-color) is applied at runtime from the venue config.
export const CONTACT_STYLES = `
:host { all: initial; }
.ax-contact {
  --ax-bg: transparent;
  --ax-fg: #0f172a;
  --ax-muted: #475569;
  --ax-border: #cbd5e1;
  --ax-input-bg: #fff;
  font: 14px/1.5 system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
  display: flex; flex-direction: column; gap: 10px; max-width: 480px;
  background: var(--ax-bg); color: var(--ax-fg);
}
.ax-contact[data-theme="dark"] {
  --ax-bg: transparent;
  --ax-fg: #e2e8f0;
  --ax-muted: #94a3b8;
  --ax-border: #475569;
  --ax-input-bg: #1e293b;
}
.ax-contact label { display: flex; flex-direction: column; gap: 4px; font-weight: 600; }
.ax-contact input, .ax-contact textarea { font: inherit; padding: 8px 10px;
  border: 1px solid var(--ax-border); border-radius: 8px;
  background: var(--ax-input-bg); color: var(--ax-fg); }
.ax-contact input::placeholder, .ax-contact textarea::placeholder { color: var(--ax-muted); }
.ax-hp { position: absolute !important; left: -9999px !important; width: 1px; height: 1px; opacity: 0; }
.ax-submit { appearance: none; border: 0; cursor: pointer; padding: 10px 16px; border-radius: 8px;
  color: #fff; background: var(--ax-color, #6366f1); font-weight: 600; }
.ax-submit:disabled { opacity: .6; cursor: default; }
.ax-status { margin: 0; font-weight: 600; }
.ax-status[hidden] { display: none; }
.ax-status[data-kind="error"]   { color: #f87171; }
.ax-status[data-kind="success"] { color: #4ade80; }
.ax-status[data-kind="pending"] { color: var(--ax-muted); }
`;
